module.exports = __webpack_public_path__ + "img/home.70b7a14c.png";